/**
 * StrategyNoteBanner — Bandeau discret affiché sur les brouillons Juliette
 * quand une note de stratégie est présente (objection prix/engagement/sensible).
 *
 * Utilisé par : PendingEmailCard, PendingWhatsAppCard, PendingEmailEditor,
 * PendingWhatsAppDialog.
 */

import { Lightbulb } from "lucide-react";
import { cn } from "@/lib/utils";

export interface StrategyNoteBannerProps {
  note: string;
  className?: string;
}

export function StrategyNoteBanner({ note, className }: StrategyNoteBannerProps) {
  return (
    <div
      className={cn(
        "flex items-start gap-1.5 rounded-md border border-primary/20 bg-primary/5 px-2.5 py-1.5",
        className,
      )}
    >
      <Lightbulb className="h-3 w-3 mt-0.5 text-primary shrink-0" />
      <p className="text-xs text-primary/80 leading-snug line-clamp-2 min-w-0">
        <span className="font-medium text-primary">Stratégie : </span>
        {note}
      </p>
    </div>
  );
}
